import AuthApi from '@/api/AuthApi'
import { applyProfileLocale } from '@/boot/plugins/i18n'
import { useAuthStore } from '@/stores/auth'

interface ApiFailure {
  kind?: string
}

/**
 * Loads the signed-in profile behind an existing cookie. Called from
 * `bootstrap()` before mount, so the first rendered frame already knows who the
 * user is. Never rejects — a failure here must not stop the app mounting.
 */
export async function hydrateSession(): Promise<void> {
  const store = useAuthStore()
  if (!store.isLoggedIn) return

  try {
    const user = await AuthApi.authUser()
    store.setUser(user)
    await applyProfileLocale(user.setting?.settings.locale)
  } catch (error) {
    // Only a rejected token proves the session is dead. A dropped connection
    // does not, and clearing on that would sign people out of working sessions
    // every time the network hiccups at boot.
    if ((error as ApiFailure).kind === 'unauthenticated') {
      store.clearSession()
    }
  }
}
